<template>
  <div class="team-container">
    <div
      v-for="(member, index) in teams"
      :key="index"
      :class="team-member"
      :style="{ '--border-color': member.color }"
      >
      <div class="label">{{ member.label }}</div>
      <div :class="index === 1 ? 'circle-image-1 circle-image' : 'circle-image-2 circle-image'">
        <img :class="index === 1 ? 'circle-img' : 'circle-img-2'" :src="member.image" alt="Team photo" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TeamCircles',
  data() {
    return {
      teams: [
        {
          label: 'Business Development Team',
          image: './about/circle1.jpg',
          color: '#3F51B5', 
        },
        {
          label: 'Software and AI Engineers',
          image: './about/circle2.jpg',
          color: '#2EBDED', 
        },
        {
          label: 'Epidemiologists and Analysts',
          image: './about/circle3.jpg',
          color: '#287DBD', 
        },
      ],
    };
  },
};
</script>

<style scoped>

.label {
  font-family: Roberto, Avenir Next, Cochin, Georgia, Times, 'Times New Roman', serif;
  color: white;
  font-size: 1.5rem;
  margin-bottom: 3%;
}

.team-container {
  display: flex;
  justify-content: center;
  padding: 1rem;
  background: #0a1733;
  flex-wrap: wrap;
  text-align: center;
}

.team-member {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
  max-width: 220px;
}
.circle-img {
  transform: rotate(45deg);
}
.circle-img-2 {
  transform: rotate(-135deg);
}

.circle-image {
    width: 400px;
    height: 400px;
    border: 1.5em solid var(--border-color);
    border-radius: 50%;
    margin-left: 30px;
    padding: 30px;
    border-bottom-color: transparent;
    border-left-color: transparent;
}
.circle-image-1 {
  transform: rotate(-45deg);
}


.circle-image-2 {
  transform: rotate(135deg);
}
.text-field-wrapper {
  width: 100%;
  display: flex;
  justify-content: flex-end !important;
  align-items: right;
}

@media (max-width: 600px) {
  .circle-image {
    transform: rotate(45deg);
    margin-left: 0px;

  }

  .circle-image-2 {
    transform: rotate(-135deg);
  }

  .circle-img {
  transform: rotate(-45deg);
}
.circle-img-2 {
  transform: rotate(135deg);
}
}

.circle-image img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}
.circle-image-2 img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.label {
  margin-top: 1rem;
  font-weight: 500;
}
</style>
